import React from 'react';
import { CgSpinner } from 'react-icons/cg';
// import { container, container_inline } from "./styles.module.scss";
import styles from './styles.module.scss';

export function FullPageSpinner() {
  return (
    <div className={styles.container}>
      <CgSpinner fontSize={35} aria-label="loading" />
    </div>
  );
}

export function Spinner(props) {
  const { color = '', size = '' } = props;
  return (
    <div className={styles.container_inline}>
      <CgSpinner color={color} size={size} aria-label="loading" />
    </div>
  );
}
